module.exports = __webpack_public_path__ + "img/home-credit-logo.77df831f.svg";